export const en = {
  // App
  appName: 'CarTrip',
  
  // Auth
  signIn: 'Sign In',
  signUp: 'Sign Up',
  signOut: 'Sign Out',
  email: 'Email',
  emailAddress: 'Email Address',
  password: 'Password',
  fullName: 'Full Name',
  enterEmail: 'Enter your email',
  enterPassword: 'Enter your password',
  enterFullName: 'Enter your full name',
  authentication: 'Authentication',
  planTripsEase: 'Plan your trips with ease',
  loginRequired: 'Login Required',
  loginRequiredDescription: 'Please sign in to create and manage trip stops',
  
  // Navigation
  home: 'Home',
  profile: 'Profile',
  settings: 'Settings',
  menu: 'Menu',
  analytics: 'Analytics',
  
  // Trips
  myTrips: 'My Trips',
  newTrip: 'New Trip',
  selectTrip: 'Select Trip',
  tripName: 'Trip Name',
  createTrip: 'Create Trip',
  deleteTrip: 'Delete Trip',
  noTrips: 'No trips yet. Create your first trip!',
  stops: 'stops',
  stopsTitle: 'Stops',
  tripHistory: 'Trip History',
  searchTrips: 'Search trips...',
  all: 'All',
  noTripsFound: 'No Trips Found',
  createTripsToSeeHistory: 'Create some trips to see your history',
  sortBy: 'Sort by',
  newestFirst: 'Newest First',
  oldestFirst: 'Oldest First',
  nameAZ: 'Name (A-Z)',
  nameZA: 'Name (Z-A)',
  longestDistance: 'Longest Distance',
  highestCost: 'Highest Cost',
  cost: 'Cost',
  complete: 'Complete',
  archive: 'Archive',
  restore: 'Restore',
  view: 'View',
  tripCompleted: 'Trip marked as completed',
  tripArchived: 'Trip archived successfully',
  tripRestored: 'Trip restored successfully',
  tripDeleted: 'Trip deleted successfully',
  errorCompletingTrip: 'Error completing trip',
  errorDeletingTrip: 'Error deleting trip',
  confirmDeleteTrip: 'Are you sure you want to delete this trip',
  exportPDF: 'Export PDF',
  exportExcel: 'Export Excel',
  pdfExported: 'PDF downloaded successfully',
  excelExported: 'Excel downloaded successfully',
  exportFailed: 'Export failed. Please try again.',
  
  // Trip actions
  deleteConfirm: 'Are you sure you want to delete',
  deleteMessage: 'This will also delete all',
  cancel: 'Cancel',
  delete: 'Delete',
  close: 'Close',
  save: 'Save',
  back: 'Back',
  
  // Stops
  addStop: 'Add Stop',
  editStop: 'Edit Stop',
  deleteStop: 'Delete Stop',
  noStops: 'No stops yet',
  start: 'Start',
  finish: 'Finish',
  route: 'Route',
  stop: 'stop',
  address: 'Address',
  stopType: 'Stop Type',
  stopName: 'Stop Name',
  notes: 'Notes',
  coordinates: 'Coordinates',
  latitude: 'Latitude',
  longitude: 'Longitude',
  plannedDuration: 'Planned Duration (minutes)',
  selectType: 'Select type',
  useMapCenter: 'Use map center',
  coordinatesAutoFilled: 'Coordinates are filled automatically when you search for an address',
  howLongToStay: 'How long do you plan to stay at this stop?',
  enterStopName: 'Enter stop name',
  updateStop: 'Update Stop',
  
  // Stop types
  city: 'City',
  gasStation: 'Gas Station',
  evCharging: 'EV Charging',
  restArea: 'Rest Area',
  restaurant: 'Restaurant',
  fastFood: 'Fast Food',
  cafe: 'Cafe',
  hotel: 'Hotel',
  motel: 'Motel',
  camping: 'Camping',
  attraction: 'Attraction',
  museum: 'Museum',
  park: 'Park',
  viewpoint: 'Viewpoint',
  shopping: 'Shopping',
  parking: 'Parking',
  other: 'Other',
  accommodation: 'Accommodation',
  
  // Map
  mapLabels: 'Map Labels',
  cityAndStreetNames: 'City and street names',
  localLanguage: 'Local',
  englishLanguage: 'English',
  
  // Settings
  language: 'Language',
  languageNative: 'Language',
  theme: 'Theme',
  themeLight: 'Light',
  themeDark: 'Dark',
  themeAuto: 'Auto',
  appearance: 'Appearance',
  map: 'Map',
  account: 'Account',
  security: 'Security',
  
  // Regional settings
  regional: 'Regional',
  units: 'Units',
  distanceUnit: 'Distance Unit',
  speedUnit: 'Speed Unit',
  fuelUnit: 'Fuel Consumption Unit',
  currencySettings: 'Currency',
  dateTimeFormat: 'Date & Time Format',
  dateFormat: 'Date Format',
  timeFormat: 'Time Format',
  
  // Security & 2FA
  twoFactorAuth: 'Two-Factor Authentication',
  twoFactorAuthDescription: 'Add an extra layer of security to your account',
  twoFactorEnabled: '2FA Enabled',
  twoFactorEnabledDesc: 'Your account is protected with two-factor authentication',
  twoFactorDisabled: '2FA Disabled',
  twoFactorDisabledDesc: 'Enable 2FA to protect your account',
  setupTwoFactor: 'Setup Two-Factor Authentication',
  setupTwoFactorStep1: 'Step 1: Scan QR Code',
  scanQRCode: 'Scan this QR code with your authenticator app',
  cantScanQR: 'Can\'t scan the QR code?',
  enterManually: 'Enter this code manually',
  enterVerificationCode: 'Enter the 6-digit code from your authenticator app',
  verificationCode: 'Verification Code',
  verify: 'Verify',
  enableTwoFactor: 'Enable',
  disableTwoFactor: 'Disable',
  next: 'Next',
  copy: 'Copy',
  copiedToClipboard: 'Copied to clipboard',
  invalidVerificationCode: 'Invalid verification code',
  errorStartingMFA: 'Error starting two-factor setup',
  errorDisablingMFA: 'Error disabling two-factor authentication',
  disableTwoFactorTitle: 'Disable Two-Factor Authentication',
  disableTwoFactorConfirm: 'Are you sure you want to disable two-factor authentication? This will make your account less secure.',
  
  // GDPR & Privacy
  privacyAndData: 'Privacy & Data',
  privacyDescription: 'Manage your privacy settings, data, and account preferences',
  cookiePreferences: 'Cookie Preferences',
  manageCookieSettings: 'Control which cookies we use',
  manageCookies: 'Manage Cookies',
  cookieConsentTitle: 'We use cookies',
  cookieConsentMessage: 'We use cookies to enhance your experience, analyze site traffic, and for marketing purposes.',
  cookieSettings: 'Cookie Settings',
  cookieSettingsDescription: 'Choose which cookies you want to allow',
  acceptAll: 'Accept All',
  cookieNecessary: 'Necessary Cookies',
  cookieNecessaryDesc: 'Essential for the website to function properly',
  cookieFunctional: 'Functional Cookies',
  cookieFunctionalDesc: 'Remember your preferences and settings',
  cookieAnalytics: 'Analytics Cookies',
  cookieAnalyticsDesc: 'Help us understand how visitors use our website',
  cookieMarketing: 'Marketing Cookies',
  cookieMarketingDesc: 'Used to deliver personalized advertisements',
  savePreferences: 'Save Preferences',
  cookiePreferencesSaved: 'Cookie preferences saved',
  emailPreferences: 'Email Preferences',
  emailPreferencesDesc: 'Choose which emails you want to receive',
  marketingEmails: 'Marketing Emails',
  marketingEmailsDesc: 'Product updates, tips, and special offers',
  tripReminders: 'Trip Reminders',
  tripRemindersDesc: 'Reminders about your upcoming trips',
  weeklySummary: 'Weekly Summary',
  weeklySummaryDesc: 'Weekly overview of your travel activity',
  emailPreferencesSaved: 'Email preferences saved',
  errorSavingPreferences: 'Error saving preferences',
  exportYourData: 'Export Your Data',
  exportYourDataDesc: 'Download a copy of all your data',
  downloadMyData: 'Download My Data',
  exporting: 'Exporting...',
  dataExportedSuccessfully: 'Your data has been downloaded',
  errorExportingData: 'Error exporting data',
  privacyPolicy: 'Privacy Policy',
  privacyPolicyDesc: 'Read our privacy policy and terms',
  viewPrivacyPolicy: 'View Privacy Policy',
  deleteAccount: 'Delete Account',
  deleteAccountDesc: 'Permanently delete your account and all data',
  deleteMyAccount: 'Delete My Account',
  deleteAccountConfirmTitle: 'Delete Account?',
  deleteAccountConfirmMessage: 'This will permanently delete your account, all trips, vehicles, and settings. This action cannot be undone.',
  accountDeletedSuccessfully: 'Your account has been deleted',
  errorDeletingAccount: 'Error deleting account',
  
  // Messages
  createFirstTrip: 'Click the ➕ button to create your first trip',
  noActiveTrip: 'No active trip. Please create or select a trip first.',
  error: 'Error',
  success: 'Success',
  
  // Trip calculator
  distance: 'Distance',
  duration: 'Duration',
  totalDistance: 'Total Distance',
  totalDuration: 'Total Duration',
  fuelCost: 'Fuel Cost',
  tripCalculator: 'Trip Calculator',
  tripSummary: 'Trip Summary',
  fuelConsumption: 'Fuel Consumption (L/100km)',
  fuelPrice: 'Fuel Price (€/L)',
  kilometers: 'Kilometers',
  totalTime: 'Total Time',
  fuelNeeded: 'Fuel Needed',
  breakdown: 'Breakdown',
  drivingTime: 'Driving time',
  stopDuration: 'Stop duration',
  avgSpeed: 'Avg. speed',
  addTwoStops: 'Add at least 2 stops to see calculations',
  upgradeToPremium: 'Upgrade to Premium',
  premiumFeatures: 'Get toll calculations, fuel station finder, and more advanced features',
  upgradeNow: 'Upgrade Now',
  
  // Vehicles
  vehicles: 'Vehicles',
  myVehicles: 'My Vehicles',
  vehicle: 'Vehicle',
  addVehicle: 'Add Vehicle',
  addNewVehicle: 'Add New Vehicle',
  editVehicle: 'Edit Vehicle',
  noVehicles: 'No vehicles yet',
  vehicleName: 'Vehicle Name',
  selectedVehicle: 'Selected Vehicle',
  noVehicleSelected: 'No vehicle selected',
  customVehicle: 'Custom vehicle',
  change: 'Change',
  done: 'Done',
  make: 'Make',
  model: 'Model',
  year: 'Year',
  fuelType: 'Fuel Type',
  gasoline: 'Gasoline',
  diesel: 'Diesel',
  electric: 'Electric',
  hybrid: 'Hybrid',
  pluginHybrid: 'Plug-in Hybrid',
  fuelConsumptionLabel: 'Consumption',
  fuelConsumptionCity: 'City',
  fuelConsumptionHighway: 'Highway',
  fuelConsumptionCombined: 'Combined',
  tankCapacity: 'Tank Capacity',
  batteryCapacity: 'Battery Capacity',
  range: 'Range',
  chargingSpeed: 'Charging Speed',
  color: 'Color',
  icon: 'Icon',
  setAsDefault: 'Set as default',
  defaultVehicle: 'Default',
  
  // Cost tracking
  costs: 'Costs',
  addCost: 'Add Cost',
  editCost: 'Edit Cost',
  costCategory: 'Category',
  costAmount: 'Amount',
  costDescription: 'Description',
  costDate: 'Date',
  totalCost: 'Total Cost',
  fuelCostLabel: 'Fuel Cost',
  otherCosts: 'Other Costs',
  
  // Cost categories
  costFuel: 'Fuel',
  costToll: 'Toll',
  costParking: 'Parking',
  costAccommodation: 'Accommodation',
  costMeal: 'Meal',
  costAttraction: 'Attraction',
  costMaintenance: 'Maintenance',
  costOther: 'Other',
  currency: 'Currency',
  linkToStop: 'Link to Stop',
  optional: 'Optional',
  noStop: 'No stop',
  manage: 'Manage',
  topCategories: 'Top Categories',
  
  // POI Search
  searchPOI: 'Search Places',
  allCategories: 'All Categories',
  fuelAndCharging: 'Fuel & Charging',
  foodAndDrink: 'Food & Drink',
  accommodationCategory: 'Accommodation',
  attractionsCategory: 'Attractions',
  parkingCategory: 'Parking',
  restAreas: 'Rest Areas',
  shoppingCategory: 'Shopping',
  searchRadius: 'Search Radius',
  nearCurrentLocation: 'Near Me',
  alongRoute: 'Along Route',
  searching: 'Searching...',
  search: 'Search',
  foundResults: 'Found {count} places',
  noResultsFound: 'No results found',
  tryDifferentSearch: 'Try a different category or increase radius',
  selectCategoryAndSearch: 'Select a category and tap Search',
  locationRequired: 'Current location required',
  routeRequired: 'Route required for this search',
  searchFailed: 'Search failed. Please try again.',
  poiServiceUnavailable: 'POI search service is temporarily unavailable. Please try again in a few moments.',
  
  // Statistics
  statistics: 'Statistics',
  totalTrips: 'Total Trips',
  totalDistanceTraveled: 'Total Distance',
  totalCostSpent: 'Total Cost',
  totalTimeSpent: 'Total Time',
  tripsByStatus: 'Trips by Status',
  active: 'Active',
  completed: 'Completed',
  archived: 'Archived',
  favoriteStopTypes: 'Favorite Places',
  monthlyTrend: 'Monthly Trend',
  lastTrip: 'Last Trip',
  uniqueStopTypes: 'Unique Stop Types',
  avgTripDistance: 'Avg Distance',
  avgTripCost: 'Avg Cost',
  noStatisticsYet: 'No Statistics Yet',
  createTripsToSeeStats: 'Create some trips to see your statistics',
  trips: 'trips',
  
  // Sharing
  shareTrip: 'Share Trip',
  shareLink: 'Share Link',
  collaborators: 'Collaborators',
  shareLinkDescription: 'Create a shareable link to let others view or collaborate on this trip',
  createNewLink: 'Create New Link',
  shareType: 'Share Type',
  viewOnly: 'View Only',
  canEdit: 'Can Edit',
  expiresIn: 'Expires In',
  never: 'Never',
  '1day': '1 Day',
  '7days': '7 Days',
  '30days': '30 Days',
  creating: 'Creating...',
  createLink: 'Create Link',
  activeLinks: 'Active Links',
  expires: 'Expires',
  views: 'Views',
  created: 'Created',
  revokeLink: 'Revoke Link',
  confirmRevokeLink: 'Are you sure you want to revoke this link? It will no longer be accessible.',
  revoke: 'Revoke',
  linkRevoked: 'Link revoked successfully',
  linkCreatedAndCopied: 'Link created and copied to clipboard',
  linkCopied: 'Link copied to clipboard',
  errorCreatingLink: 'Error creating link. Please try again.',
  collaboratorsDescription: 'Invite others to collaborate on this trip by email',
  addCollaborator: 'Add Collaborator',
  role: 'Role',
  viewer: 'Viewer',
  editor: 'Editor',
  owner: 'Owner',
  adding: 'Adding...',
  currentCollaborators: 'Current Collaborators',
  unknown: 'Unknown',
  removeCollaborator: 'Remove Collaborator',
  confirmRemoveCollaborator: 'Are you sure you want to remove this collaborator?',
  remove: 'Remove',
  collaboratorAdded: 'Collaborator added successfully',
  errorAddingCollaborator: 'Error adding collaborator. Please check the email address.',
  collaboratorRemoved: 'Collaborator removed successfully',
  
  // Shared Trip
  sharedTrip: 'Shared Trip',
  loadingSharedTrip: 'Loading shared trip...',
  errorLoadingTrip: 'Error Loading Trip',
  goHome: 'Go Home',
  sharedBy: 'Shared by',
  tripRoute: 'Trip Route',
  distanceToNext: 'Distance to next stop',
  costBreakdown: 'Cost Breakdown',
  minutes: 'min',
  
  // Notifications
  notificationSettings: 'Notification Settings',
  pushNotifications: 'Push Notifications',
  notificationsEnabled: 'Notifications are enabled',
  notificationsDisabled: 'Notifications are disabled',
  enable: 'Enable',
  notificationPreferences: 'Notification Preferences',
  tripUpdates: 'Trip Updates',
  tripUpdatesDescription: 'Get notified when trips are updated',
  tripSharedNotif: 'Trip Shared',
  tripSharedNotifDescription: 'Get notified when someone shares a trip with you',
  collaboratorNotif: 'Collaborator Added',
  collaboratorNotifDescription: 'Get notified when added as a collaborator',
  stopChanges: 'Stop Changes',
  stopChangesDescription: 'Get notified when stops are added or removed',
  costChanges: 'Cost Changes',
  costChangesDescription: 'Get notified when costs are added or updated',
  notificationHistory: 'Notification History',
  noNotifications: 'No notifications yet',
  markAllRead: 'Mark All as Read',
  notificationsEnabledSuccess: 'Notifications enabled successfully',
  notificationsEnableFailed: 'Failed to enable notifications',
  preferencesSaved: 'Preferences saved',
  allNotificationsMarkedRead: 'All notifications marked as read',
  
  // Offline Mode
  offlineMode: 'Offline Mode',
  online: 'Online',
  offline: 'Offline',
  connectionType: 'Connection',
  cellular: 'Cellular',
  pendingChanges: 'Pending Changes',
  cacheSize: 'Cache Size',
  lastSync: 'Last Sync',
  offlineModeDescription: 'Work offline and sync changes when connection is restored',
  clearOldCache: 'Clear Old Cache',
  clearAllCache: 'Clear All Cache',
  confirmClearAllCache: 'This will clear all offline data. Continue?',
  clear: 'Clear',
  pendingActions: 'Pending Actions',
  syncingOfflineChanges: 'Syncing offline changes...',
  backOnline: 'Back online',
  workingOffline: 'Working offline',
  sync: 'Sync',
  syncing: 'Syncing...',
  syncComplete: 'Sync complete',
  syncFailed: 'Sync failed',
  oldCacheCleared: 'Old cache cleared',
  allCacheCleared: 'All cache cleared',
  update: 'Update',
  
  // Premium & Subscription
  premium: 'Premium',
  freeTier: 'Free',
  upgradedSuccessfully: 'Successfully upgraded to Premium!',
  upgradeFailed: 'Upgrade failed. Please try again.',
  unlockAllFeatures: 'Unlock All Features',
  getFullAccess: 'Get full access to all premium features',
  month: 'month',
  unlimitedTrips: 'Unlimited trips',
  unlimitedStops: 'Unlimited stops per trip',
  unlimitedVehicles: 'Unlimited vehicles',
  offlineMaps: 'Offline maps',
  advancedStatistics: 'Advanced statistics',
  exportFeatures: 'Export to PDF & Excel',
  adFree: 'Ad-free experience',
  prioritySupport: 'Priority support',
  processing: 'Processing...',
  moneyBackGuarantee: '30-day money-back guarantee',
  freeTierLimits: 'Free Tier Limitations',
  maxOneTrip: 'Maximum 1 active trip',
  maxOneVehicle: 'Maximum 1 vehicle',
  maxTwelveStops: 'Maximum 12 stops per trip',
  basicStatisticsOnly: 'Basic statistics only',
  viewingDemo: 'Viewing Demo Trip',
  signInToCreate: 'Sign in to create your own trips',
  demoMode: 'Demo Mode',
  freeTierLimit: 'Free Tier Limit Reached',
  upgradeForUnlimitedTrips: 'Upgrade to Premium for unlimited trips and advanced features',
  
  // Placeholders
  tripNamePlaceholder: 'e.g., Summer Road Trip',
  searchAddress: 'Search address...',
  notesPlaceholder: 'Add notes about this stop...'
}
